// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketTotal__container___27K7p"};